import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import DescriptionCard from '../components/ui/DescriptionCard/DescriptionCard'
import TabButton from '../components/ui/TabButton/TabButton'
import PdfCard from '../components/ui/PdfCard/PdfCard'

const RiskManagement = () => {
  const { sectiondata, description } = useOutletContext() || {}
  const [selectedTab, setSelectedTab] = useState('')
  const [selectedData, setSelectedData] = useState('')
  const tabs = sectiondata?.sections

  useEffect(() => {
    if (sectiondata?.sections?.length > 0) {
      setSelectedTab(sectiondata?.sections[0]?.id)
      setSelectedData(sectiondata?.sections[0]?.pdfs)
    }
  }, [sectiondata])

  const handleClick = (id) => {
    setSelectedTab(id)
    const index = sectiondata.sections.findIndex((section) => section.id === id)
    setSelectedData(sectiondata.sections[index].pdfs)
  }
  return (
    <div>
      <DescriptionCard description={description} />
      <div className="tabs-container mb-6 md:mb-24 mt-16">
        {tabs?.map((tab, index) => {
          return (
            <TabButton
              key={index}
              id={tab?.id}
              selected={selectedTab}
              label={tab?.title}
              type="button"
              handleClick={handleClick}
            />
          )
        })}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
        {selectedData &&
          selectedData?.map((card, index) => {
            return (
              <PdfCard
                key={index}
                title={card?.title}
                link={card?.fileinfo?.url}
                fileName={card?.fileinfo?.name}
                isView={true}
                isDownload={false}
              />
            )
          })}
      </div>
    </div>
  )
}

export default RiskManagement
